import api from '../../../api';

export function getUserData() {
  return api.get('/usuarios/atual');
}

export function getListMenu() {
  return api.get('/menu');
}